import { walletDocumentsDataQa } from '~/constants/commons/data-qa';

export const removePluralS = (word: string) => {
  if (word?.toLowerCase()?.endsWith('s') && word.length > 1) {
    return word.slice(0, -1);
  }
  return word;
};

export const getDocumentDataQa = (value: number) => {
  const labelMap: { [key: number]: string } = {
    0: walletDocumentsDataQa?.idListBtn,
    1: walletDocumentsDataQa?.proofOfAddressListBtn,
    2: walletDocumentsDataQa?.bank_account_statement,
    3: walletDocumentsDataQa?.eu_passport,
    4: walletDocumentsDataQa?.non_eu_passport,
    5: walletDocumentsDataQa?.residence_permit,
    7: walletDocumentsDataQa?.company_registration,
    11: walletDocumentsDataQa?.drivers_license,
    12: walletDocumentsDataQa?.articles_of_association,
    13: walletDocumentsDataQa?.selfie,
    21: walletDocumentsDataQa?.sdd_mandate
  };
  return labelMap[value] || walletDocumentsDataQa?.other;
};

export const capitalize = (word?: string): string | undefined => {
  return word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : undefined;
};

export const toPascalCaseName = (name?: string): string =>
  !name
    ? ''
    : name
        .toLowerCase()
        .replace(
          /(^|\s|'|-)([a-zà-öø-ÿ])/g,
          (_, separator, letter) => separator + letter.toUpperCase()
        );
